<template>
  <LegalPage
    title="Términos y condiciones de uso"
    updated-at="30 de agosto de 2026"
    :sections="sections"
  />
</template>

<script>
import LegalPage from './LegalPage.vue';

export default {
  name: 'TermsPage',
  components: { LegalPage },
  data() {
    return {
      sections: [
        {
          id: 'objeto',
          title: '1. Objeto y aceptación',
          paragraphs: [
            'Estos términos regulan el uso de este sitio web y la solicitud de servicios a Selk a través de sus formularios y canales de contacto. Al usar el sitio o enviar una solicitud, aceptas las condiciones descritas aquí.',
          ],
        },
        {
          id: 'servicios',
          title: '2. Servicios',
          paragraphs: [
            'Selk presta servicios en tres áreas: impresión 3D (modelado y fabricación de piezas), automatización de procesos y desarrollo de aplicativos y sitios web. El alcance concreto de cada trabajo es el que se defina en la cotización aceptada por el cliente.',
          ],
        },
        {
          id: 'cotizaciones',
          title: '3. Cotizaciones y precios',
          paragraphs: [
            'Los valores que se muestran en el sitio y los cálculos automáticos de la sección de impresión 3D son estimaciones de referencia. No constituyen una oferta en firme: el precio definitivo se confirma en la cotización que enviamos tras revisar tu solicitud.',
            'Las cotizaciones tienen la vigencia que se indique en cada documento y pueden variar por cambios en el alcance, en las especificaciones de la pieza o en los costos de materiales.',
          ],
        },
        {
          id: 'archivos',
          title: '4. Archivos y propiedad intelectual',
          paragraphs: [
            'Al subir un archivo (modelo 3D, imagen o documento de referencia) declaras que cuentas con los derechos necesarios para usarlo y para encargar su fabricación o desarrollo.',
            'Los archivos que nos envías siguen siendo tuyos. Nos autorizas a usarlos únicamente para cotizar y ejecutar el trabajo solicitado. No fabricamos piezas que infrinjan derechos de terceros ni contenidos ilícitos, y podemos rechazar una solicitud por este motivo.',
            'Los desarrollos, modelos y materiales creados por Selk se rigen por lo pactado en la cotización o el contrato correspondiente.',
          ],
        },
        {
          id: 'plazos',
          title: '5. Plazos y entregas',
          paragraphs: [
            'Los tiempos de entrega se acuerdan por proyecto y empiezan a contar desde la aceptación de la cotización y, cuando aplique, desde el pago del anticipo. Los plazos pueden ajustarse si el cliente modifica el alcance o si se presentan demoras en la entrega de información o de insumos.',
          ],
        },
        {
          id: 'responsabilidad',
          title: '6. Limitación de responsabilidad',
          paragraphs: [
            'Selk responde por la correcta ejecución de los servicios contratados según las especificaciones acordadas. No respondemos por usos distintos a los previstos para la pieza o el sistema entregado, ni por daños derivados de información incompleta o inexacta suministrada por el cliente.',
            'El sitio web se ofrece "tal cual". Procuramos que la información esté actualizada, pero no garantizamos que esté libre de errores ni que el servicio esté disponible de forma ininterrumpida.',
          ],
        },
        {
          id: 'datos',
          title: '7. Datos personales',
          paragraphs: [
            'El tratamiento de los datos personales que nos entregas se rige por nuestra Política de privacidad, disponible en este mismo sitio.',
          ],
        },
        {
          id: 'ley',
          title: '8. Ley aplicable',
          paragraphs: [
            'Estos términos se rigen por la legislación de la República de Colombia. Cualquier controversia se resolverá ante los jueces competentes del territorio colombiano.',
          ],
        },
      ],
    };
  },
};
</script>
